import { configureStore } from "@reduxjs/toolkit";
import { contactUsSlice } from "./slices/ContactUsSilces";

const store = configureStore({
    reducer: {
        data: contactUsSlice.reducer
    }
})

export default store;